export default "__VITE_ASSET__ULeAkThn__"